
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ManagerAccessDeniedWarning from "@/components/alert/ManagerAccessDeniedWarning.vue";

  import { User, Company } from "@/generated/graphql"
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      ManagerAccessDeniedWarning,
    }
  })
  export default class ManagerSuspendedGuard extends Vue {
    @Prop({type: Object, required: true}) readonly currentUser!: User;
    @Prop({type: Object, default: undefined}) readonly company!: Company;

    get managerSuspended(): boolean {
      const managerUserRole = this.currentUser.role === Roles.MANAGER;
      if (!managerUserRole) {
        return false;
      }
      return this.currentUser.manager!.status === "SUSPENDED";
    }
  }
